import React, { useState } from "react";
import { Document, Page } from "react-pdf";
import { FileText } from "lucide-react";
import "@/utils/pdfWorker";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
import { getCertificateFileUrl, isPdfFile } from "@/utils/certificateFile";

/**
 * Compact first-page PDF preview for cards (list + home).
 */
const CertificatePdfThumbnail = ({ file, alt = "Certificate", className = "" }) => {
  const [error, setError] = useState(false);
  const url = getCertificateFileUrl(file);

  if (!url || !isPdfFile(file) || error) {
    return (
      <div
        className={`w-full h-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-purple-50 to-muted dark:from-purple-950/30 dark:to-muted ${className}`}
      >
        <FileText className="w-12 h-12 text-red-500" />
        <span className="text-xs text-muted-foreground">PDF Certificate</span>
      </div>
    );
  }

  return (
    <div className={`w-full h-full overflow-hidden bg-muted flex items-center justify-center ${className}`}>
      <Document
        file={url}
        loading={
          <div className="w-full h-full min-h-[160px] bg-muted animate-pulse" />
        }
        onLoadError={() => setError(true)}
        error={
          <div className="w-full h-full flex flex-col items-center justify-center gap-2">
            <FileText className="w-12 h-12 text-red-500" />
            <span className="text-xs text-muted-foreground">PDF Certificate</span>
          </div>
        }
      >
        <Page
          pageNumber={1}
          width={400}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          className="!max-w-full [&_canvas]:!max-w-full [&_canvas]:h-auto"
        />
      </Document>
    </div>
  );
};

export default CertificatePdfThumbnail;
